import { render, staticRenderFns } from "./PartNumberRestoreContainer.vue?vue&type=template&id=37068db4"
import script from "./PartNumberRestoreContainer.vue?vue&type=script&lang=js"
export * from "./PartNumberRestoreContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports